import { METODO } from "@/config/site";

export const Metodo = () => (
  <section className="bg-warm py-20 lg:py-28" data-testid="metodo-section">
    <div className="container-ph">
      <div className="reveal max-w-xl">
        <span className="gold-line mb-5" />
        <h2 className="h-section">Il nostro metodo</h2>
      </div>
      <ol className="mt-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {METODO.map((m, i) => (
          <li key={m.n} className={`reveal reveal-delay-${Math.min(i, 3)} border-t border-ivory-dark pt-6`} data-testid={`metodo-step-${m.n}`}>
            <span className="font-serif text-5xl text-bronze leading-none">{m.n}</span>
            <h3 className="mt-5 text-xs font-bold tracking-[0.18em] text-forest">{m.title}</h3>
            <p className="mt-3 text-sm text-ink/75 leading-relaxed">{m.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
